import { render, staticRenderFns } from "./PaginaAdminListas.vue?vue&type=template&id=58bc1526&lang=es"
import script from "./PaginaAdminListas.vue?vue&type=script&lang=js"
export * from "./PaginaAdminListas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports